// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accessibleView":"obrzD"};